import { useTheme } from "@mui/material/styles";
export var MaskedInputStyles = function () {
    var theme = useTheme();
    return {
        wrapper: function (error) { return ({
            padding: "14px 16px",
            borderRadius: "8px",
            border: "1px solid ".concat(error ? theme.palette.error.dark : theme.palette.grey[200]),
            color: theme.palette.grey[700],
            fontSize: "0.875rem",
            lineHeight: "23px",
        }); },
    };
};
